import React  from 'react'
import {Gallery, Item} from "react-photoswipe-gallery"
import { useTranslation } from 'react-i18next';
import './styles.css';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import { noraWebTheme } from './noraWebTheme';
import ThemeProvider from '@mui/material/styles/ThemeProvider';
import createTheme from '@mui/material/styles/createTheme';


export default function PhotoSwipeG(props) {
    const { t } = useTranslation(['common','materials','media']);

    const captionTextHTLM = (title,mediaKey,materialKey,sizeVal) => {
        const titleRet = !!(title)?"<p class='caption'>" + title + "</p>":"";
        const materialVal = t("materials:" + materialKey);
        const materialRet = !!(materialVal)?"<p class='caption'>"+t("LABEL_MATERIAL",{ ns: 'common' }) + ":" + materialVal + "</p>" :null;
        const mediaVal = t("media:" + mediaKey);
        const mediaRet = !!(mediaVal)?"<p class='caption'>" + t("LABEL_MEDIA",{ ns: 'common' }) + ":" + mediaVal + "</p>":null;
        const sizeRet = !!(sizeVal)?"<p class='caption'>" + sizeVal + "</p>":null;
        return titleRet + mediaRet + materialRet + sizeRet;
      };

      const BREAKPOINTS = {
        xs: 0,
        sm: 610,
        md: 920,
        lg: 1230,
        xl: 1540,
      };
      const breakpointsValues = {
        breakpoints: {
          values: BREAKPOINTS
        }
      };
      const gridTheme = createTheme({ ...noraWebTheme, ...breakpointsValues });

    const ContainerStyling = {
        backgroundColor: 'background.paper',
        flexGrow:1,
        mt:{xs:11,sm:6},
        pt:{xs:0,md:5}
    }

    const mdBP = !!(12/props.images.imgPerRow > 4)? 12/props.images.imgPerRow:4;

    console.log(captionTextHTLM(props.images.children[0].title,props.images.children[0].mediaKey,props.images.children[0].materialKey,props.images.children[0].size));

    return (
        <ThemeProvider theme={gridTheme}>
            <Grid2 container rowSpacing={2} sx={ContainerStyling}>
                <Gallery withCaption id={props.images.id}>
                    {props.images.children.map((image, index) => (
                        <Grid2 sx={{mb:{xs:2,sm:4}}} key={image.imgUrl} display='flex' alignItems='center' justifyContent='center' xs={12} sm={6} md={mdBP} lg={12/props.images.imgPerRow}>
                            <Item
                                original={image.imgUrl}
                                thumbnail={image.tnUrl}
                                width={image.imgWidth}
                                height={image.imgHeight}
                                caption={captionTextHTLM(image.title,image.mediaKey,image.materialKey,image.size)}
                            >
                                {({ref,open}) => (
                                    <img 
                                        ref={ref} 
                                        onClick={open} 
                                        src={image.tnUrl}
                                        alt={image.title}
                                        width={image.tnWidth}
                                        height={image.tnHeight}
                                    />
                                )}
                            </Item>
                        </Grid2>
                    ))}
                </Gallery>
            </Grid2>
        </ThemeProvider>

    )
}
